import { useState } from 'react';
import { STATUS_COMMENT_MAX_LENGTH } from 'constants/constants';
import { useTranslation } from 'react-i18next';
import StatusCommentFullViewDialog from './dialogs/StatusCommentFullViewDialog';
import styled from 'styled-components';
import { ReadMoreInlineButton } from 'styles/v2/Styles.styled';

const LicenseeAdminReviewCommentBox = ({ comment }: { comment: string }) => {
  const [showLicenseeAdminReviewViewDialog, setShowLicenseeAdminReviewViewDialog] = useState(false);

  const { t } = useTranslation();

  const commentPostProcessed =
    comment && (comment.length > STATUS_COMMENT_MAX_LENGTH ? comment.slice(0, STATUS_COMMENT_MAX_LENGTH) + '…' : comment);

  return (
    <ContentWrapper>
      <Title>{t('epdWizard.epdState.licenseeAdminReviewCommentTitle')}</Title>
      <span>
        {commentPostProcessed}{' '}
        {commentPostProcessed.length > STATUS_COMMENT_MAX_LENGTH && (
          <ReadMoreInlineButton onClick={() => setShowLicenseeAdminReviewViewDialog(true)}>Read more</ReadMoreInlineButton>
        )}
      </span>
      <StatusCommentFullViewDialog
        headerTitle={t('epdWizard.epdState.licenseeAdminReviewCommentTitle')}
        comment={comment}
        isOpened={showLicenseeAdminReviewViewDialog}
        onClose={() => setShowLicenseeAdminReviewViewDialog(false)}
      />
    </ContentWrapper>
  );
};

const ContentWrapper = styled.div`
  position: relative;
  border-radius: 4px;
  padding: 17px 16px;
  flex-shrink: 0;
  background-color: ${(props) => props.theme.colors.elementsDropDown};
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  margin-bottom: 16px;
`;

const Title = styled.span`
  color: ${(props) => props.theme.colors.primaryBlack};
  font-size: 12px;
  text-transform: uppercase;
  font-weight: 600;
  margin-right: 24px;
`;

export default LicenseeAdminReviewCommentBox;
